import React from "react";
import { HelmetDexteel } from "@dexteel/mesf-core";
import { FormsProvider } from "./context/FormsContext";
import { ConfigurationFormsPage } from "./FormsPage";

const FormsPage = () => {
	return (
		<>
			<HelmetDexteel title="Forms Configuration" />
			<FormsProvider>
				<ConfigurationFormsPage />
			</FormsProvider>
		</>
	);
};

export default FormsPage;
